import { createFileRoute } from '@tanstack/react-router';
import { CustomerProfilePage } from '@/features/crm/pages/customer-profile-page';

export const Route = createFileRoute('/_app/customers/$customerId')({
  component: function CustomerRoute() {
    const { customerId } = Route.useParams();
    return <CustomerProfilePage customerId={customerId} />;
  },
});
